import { Form } from "antd";
import PropTypes from "prop-types";

import ProgressBar, {
  ProgressBarProps,
} from "@/components/Elements/ProgressBar";

const ProgressEditField = ({
  name = "progress",
  label = "",
  ...progressBarProps
}) => (
  <Form.Item name={name} label={label}>
    <ProgressBar {...progressBarProps} isEditable />
  </Form.Item>
);

ProgressEditField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  ...ProgressBarProps,
};

export default ProgressEditField;
